import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import {
  useCustomManagementCreateMutation,
  useCustomManagementUpdateMutation,
} from 'components/company/hooks/useCompany';
import styled from 'styled-components';
import './index.scss';
import TooglCustom from 'components/_parts/atoms/toogle';
import initialValues from './initialValues';
import validationSchema from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonInfo = styled(Button)`
  width: 100%;
  width: fit-content;
  height: 40px;
  min-width: 147px;
  border: 1px solid #3d5afe;
  background-color: #ffffff;
  color: #3d5afe;
  padding: 12px 16px;
  column-gap: 10px;
`;

function WorkerType(props) {
  const createCustomManagementMutation = useCustomManagementCreateMutation();
  const updateCustomManagementMutation = useCustomManagementUpdateMutation();
  const { t } = props;
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: async (values) => {
      try {
        if (props.typeForm === 'edit') {
          await updateCustomManagementMutation.mutateAsync({
            data: {
              ...formik.values,
              type: 'edit',
            },
            ids: props.ids,
          });
          // window.location = "localhost:3000/company?custom_management=true";
        } else {
          await createCustomManagementMutation.mutateAsync({
            data: {
              ...formik.values,
              type: 'create',
            },
          });
          // window.location = "localhost:3000/company?custom_management=true";
        }
        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
  });

  useEffect(() => {
    if (props.typeForm === 'edit') {
      formik.setValues({
        title: props.data?.title,
        status: props.data?.status,
        wla_adhoc_group_id: props?.data?.wla_adhoc_group_id,
      });
    } else {
      formik.setValues({
        title: '',
        status: 'active',
      });
    }
  }, [props.typeForm]);

  useEffect(() => {
    if (props.showModal) {
      formik.resetForm();
    }
  }, [props.showModal]);

  let isChecked = 0;
  if (formik.values.status !== undefined) {
    isChecked = formik.values.status === 'active' ? 0 : 1;
  }

  return (
    <div>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('workload_landing.custom_category')}`}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    isError={
                      formik.touched.title && Boolean(formik.errors.title)
                    }
                    validateMessage={formik.errors.title}
                    type="text"
                    name="title"
                    onChange={formik.handleChange}
                    value={formik?.values?.title}
                    placeholder={t('company.category_name')}
                  />
                </div>
              </div>
              { props.typeForm === 'edit' && (
                <div className="d-flex justify-content-between">
                  <p style={{
                    fontSize: '12px', fontWeight: '700', fontFamily: 'Quicksand', paddingLeft: '5px',
                  }}
                  >
                    {t('job_desc.status')}
                  </p>
                  <TooglCustom
                    id="button-visibility"
                    name="status"
                    checked={isChecked}
                    leftStatus={t('org.job_lvl.form.active')}
                    rightStatus={t('org.job_lvl.form.inactive')}
                    onChange={() => {
                      formik.setValues({
                        ...formik.values,
                        status:
                          formik.values.status === 'active' ? 'inactive' : 'active',
                      });
                    }}
                  />
                </div>
              )}
              <div className="d-flex justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('custom_category_list'),
        )}
    </div>
  );
}

export default WorkerType;
